import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SplitIcon } from '../../../../assets/svg/split-icon.svg';

export const SplitLink = ({ handleOnClick } : { handleOnClick: () => void }) => {
  const { t } = useTranslation();
  return (
    <button type='button' className='text-[12px] font-metricRSemibold text-bw06 flex items-center cursor-pointer' onClick={handleOnClick} data-testid='categorization-split-text-button'>
      <SplitIcon className='mr-[5px]' />
      {t('CATEGORIZE_EXPENSES_COMPONENT_SPLIT_LABEL')}
    </button>
  );
};
